import { render, staticRenderFns } from "./yuehanjie.vue?vue&type=template&id=b8d5c248&scoped=true&"
import script from "./yuehanjie.vue?vue&type=script&lang=js&"
export * from "./yuehanjie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d5c248",
  null
  
)

export default component.exports